import axios from 'axios';

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// BAG API
export const bagsApi = {
  getAll: () => api.get('/bags'),
  getById: (id) => api.get(`/bags/${id}`),
  create: (data) => api.post('/bags', data),
  update: (id, data) => api.put(`/bags/${id}`, data),
  delete: (id) => api.delete(`/bags/${id}`),
};

// PRODUCT API
export const productsApi = {
  getAll: () => api.get('/products'),
  getById: (id) => api.get(`/products/${id}`),
  getByCategory: (category) => api.get(`/products?category=${category}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

// UPLOAD API
export const uploadApi = {
  uploadBagSingle: (file) => {
    const formData = new FormData();
    formData.append('bagImg', file);

    return api.post('/upload/bags/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  uploadBagMultiple: (files) => {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('images', file);
    });

    return api.post('/upload/bags/multiple', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  uploadProductSingle: (file) => {
    const formData = new FormData();
    formData.append('mainImg', file);

    return api.post('/upload/products/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  uploadProductMultiple: (files) => {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('images', file);
    });

    return api.post('/upload/products/multiple', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default api;